<div class="page-content">
    <div class="page-header">
        <h1>{{phase?.code || 'Edition'}} : {{phase?.label}}</h1>
        <div class="page-description"><ed-button [colorSchema]="buttonColors.Secondary" (click)="goToEdition()">Modifier</ed-button></div>
    </div>

    <div class="page-body">
        <div class="row g-3">
             <div class="col-sm-6 col-lg-3 g-3">
                <kpi-card
                    title="Catégorie R&D"
                    [body]="{value: phase?.researchCategory?.label || 'Pas de R&D'}"
                    [isLoading]="isLoading"
                    class="h-100"></kpi-card>
            </div>
        </div>
        <br/>
        <div class="row g-3">
            <div class="col-sm-12">
                 <table-card 
                        title="Principaux contributeurs :"
                        [isLoading]="isLoading" 
                        [dataSource]="usersData" 
                        [displayedColumns]="usersColumns"
                        (onRowClick)="goToContributor($event)"
                        [sortInfo]="{field: 'daysDeclared', order: -1}"
                        >
                    </table-card>
            </div>
        </div>

        <br/>
        <br/>
        
        <div class="row g-3">
            <div class="col-sm-12">
                 <table-card 
                        title="Détail des temps passés"
                        [isLoading]="isLoading" 
                        [dataSource]="monthlyTimeData" 
                        [displayedColumns]="monthlyTimeColumns"
                        (onRowClick)="goToContributor($event)"
                        [sortInfo]="{field: 'total', order: -1}"
                        >
                    </table-card>
            </div>
        </div>
    </div>
</div>